// removed by extract-text-webpack-plugin
module.exports = {"headingDefaults":"_1y9lJ","ellipsis":"_3jjq8"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Text/styles.scss
// module id = 145
// module chunks = 0 1